import { Component, EventEmitter, OnDestroy, OnInit, Output, Input } from '@angular/core';
import { FacebookService } from '../../services/facebook.service';
import { Subscription } from 'rxjs';
import { AccountService } from '../account.service';
import { FirebaseService } from '../../services/firebase.service';
import { ActivatedRoute } from '@angular/router';
import { FacebookPixelService } from 'app/services/facebook-pixel.service';

@Component({
  selector: 'fb-login',
  templateUrl: './facebook-login.component.html',
  styleUrls: ['./facebook-login.component.scss', '../account.scss']
})
export class FacebookLoginComponent implements OnInit, OnDestroy {
  @Input() redirectUrl;
  @Input() isSignUp;
  subscriptions = new Subscription();
  @Output() isLoading = new EventEmitter();
  @Output() setError = new EventEmitter();

  constructor(
    public accountService: AccountService,
    private facebookService: FacebookService,
    private firebaseService: FirebaseService,
    public activatedRoute: ActivatedRoute,
    private facebookPixelService: FacebookPixelService,
  ) { }

  ngOnInit() {
    this.subscriptions.add(
      this.facebookService.accessToken.subscribe(accessToken => {
        this.signInWithFacebook(accessToken);
      })
    );
  }

  signInWithFacebook(accessToken) {
    this.isLoading.emit(true);
    this.accountService.signInWithFacebook(accessToken, this.redirectUrl, this.isSignUp)
      .subscribe(
        data => {
          if (!this.isSignUp) {
            this.facebookService.setUserId(data.user_id);
            this.firebaseService.logEvent('login', {
              method: 'facebook',
            });
          } else {
            this.firebaseService.logEvent('sign_up', {
              method: 'facebook',
            });
            this.facebookPixelService.trackEvent('CompleteRegistration' , {
              method: 'facebook',
            });
          }

          this.isLoading.emit(false);
        },
        errors => {
          if (!this.isSignUp) {
            this.firebaseService.logEvent('login_error', {
              reason: errors.detail,
            });
          } else {
            this.firebaseService.logEvent('sign_up_error', {
              reason: errors.detail,
            });
          }
          this.setError.emit(errors);
          this.isLoading.emit(false);
        }
      );
  }

  fbLogin() {
    this.facebookService.login();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
